import zh_cn from './zh-cn.js';
import ru from './ru.js';
import en_us from './en_us.js';
export default {
	zh_cn,
	ru,
	en_us,
}